// extracted by mini-css-extract-plugin
module.exports = {"tabImg":"SectionF_tabImg__EDCVc"};